import React, { useState,useRef, useEffect, useContext } from "react";
import {
  Row,
  Col,
  Card,
  ButtonGroup,
  Button,
  Alert,
  Modal,
  ProgressBar,
} from "react-bootstrap";
import _ from "lodash";
import moment from "moment";
import axios from "axios";
import Utils from "./../../common/Utils";
import DateTimePicker from "react-datetime-picker";
import { UserContext } from "../../common";


const DateWise = (props) => { 
  const { userData } = useContext(UserContext);
  const [marking, setMarking] = useState(false);
  const [members, setMembers] = useState([]);
  const [confirmAttn, setConfirmAttn] = useState(false);
  const [attnmode, setAttnmode] = useState(1);
  const [attnType, setAttnType] = useState('paid');
  const [attnDate, setAttnDate] = useState(new Date());
  const [viewLogs, showViewLogs] = useState(false);
  const [logs, setLogs] = useState({loading:false, data:[], ontime: true});
  const refReason = useRef(0);
  const refType = useRef(0);
  const refDur = useRef(0);
  const refMember = useRef(0);
  const refMember2 = useRef(0);

  const fetchMembers = () => {
    setLogs({...logs,loading:true});
    axios
      .get(Utils.apiUrl("users/fetchMembers"), Utils.apiHeaders())
      .then((res) => {
        console.log(res.data);
        setMembers(res.data.members);
      })
      .catch((err) => {
        setLogs({...logs, loading:false,data:[]});
        console.log(err);
      });
  }

  useEffect(()=>{
    if(userData.manager || userData.is_super_user){
      fetchMembers();
    }
  }, []);

  const markAttendence = () => (e) => {
    
    let data = `&ts=${moment(attnDate).format("YYYY-MM-DD HH:mm:ss")}&ontime=${getAttnMode()}`;
    if(getAttnMode() === 0){
      if(refReason.current.value==''){
        alert('Please enter the Reason!');
        return;
      }
      if(refType.current.value===''){
        alert('Please select Type!');
        return;
      }
      if(refDur.current.value===''){
        alert('Please select Duration!');
        return;
      }
      data += `&diftype=${refType.current.value}&duration=${refDur.current.value}`;
      data +=`&reason=${refReason.current.value}&member=${refMember.current.value}`;
    }
    setConfirmAttn(false);
    setMarking(true);
    axios
      .post(Utils.apiUrl("attendence/mark"), data, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          props.onMark(res.data.aid);
        }else{
          alert(res.data.message);
          setConfirmAttn(true);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(()=>setMarking(false));
  };

  const fetchLogs = () => {
    setLogs({...logs,loading:true});
    axios
      .get(Utils.apiUrl(`attendence/fetchlogs?member=${refMember2.current.value}`), Utils.apiHeaders())
      .then((res) => {
        setLogs({...logs, loading:false, data: res.data.data.logs});
      })
      .catch((err) => {
        setLogs({...logs, loading:false,data:[]});
        console.log(err);
      });
  }

  useEffect(()=>{
    if(viewLogs){
      fetchLogs();
    }
  },[viewLogs]);

  const deleteAttn = (id) => {
    if (window.confirm("You are going to delete this attendence, Continue?")) {
      setLogs({...logs,loading:true});
      axios
        .post(Utils.apiUrl("attendence/deleteattn"), `id=${id}`, Utils.apiHeaders())
        .then((res) => {
          if (res.data.success) {
            fetchLogs();
          } else {
            window.alert(res.data.message);
            setLogs({...logs,loading:false});
          }
        })
        .catch((err) => {
          setLogs({...logs,loading:false});
          console.log(err);
        });
    }
  };

  const getAttnMode = () => {
   return parseInt(_.get(props,'arec.ontime',attnmode));
  };

  const confirmAttendance = () => {
    return (
      <Modal show={true} size="md" onHide={() => setConfirmAttn(false)}>
        <Modal.Header closeButton>
          <div className="d-flex align-items-center justify-content-between w-100 me-2">
            <div><b>Mark Attendance</b></div>
            <div><button className="btn btn-sm btn-outline-info" onClick={() => showViewLogs(true)}><img src={`${process.env.PUBLIC_URL}/images/notes.png`} style={{width: "15px"}} /> View Logs</button></div>
          </div>  
        </Modal.Header>
        <Modal.Body>
        {parseInt(_.get(props,'arec.id',0)) <= 0 && <div className="text-center">
          <Button className="mx-1" variant={getAttnMode()===1 ? 'primary':'secondary'} onClick={()=>setAttnmode(1)}>Normal Hours</Button>
          <Button className="mx-1" variant={getAttnMode()===0 ? 'primary':'secondary'} onClick={()=>setAttnmode(0)}>Differed Hours</Button>
        </div>}
        {parseInt(_.get(props,'arec.id',0)) > 0 && <div className="text-center alert alert-primary p-3">
          {getAttnMode() === 1 ? 'On Time' : 'Differed Time'} 
        </div>}
        
        <div className="text-center mt-3  px-5">
          <div className="m-2">
            <DateTimePicker
              disableClock={true}
              clearIcon={null}
              format="y-MM-dd"
              minDate={moment().subtract(props.attnLogDays, 'days').toDate()}
              maxDate={moment().toDate()}
              onChange={setAttnDate}
              value={attnDate}
              className="mx-2"
            />
          </div>
          {getAttnMode()===1 && <img src={`${process.env.PUBLIC_URL}/images/completed.png`} style={{width: "50px"}} />}
          {getAttnMode()===0 && <>
            {members.length > 0 && <select className="form-select my-2" ref={refMember}>
              <option value={userData.uid}>Self</option>
              {_.map(members, (m) => <option key={m.id} value={m.id}>{m.name}</option>)}
            </select>}
            <input type="text" className="form-control" placeholder="Reason for Differed Time" ref={refReason} />
            <div className="d-flex mt-2">
              <select className="form-select me-1" ref={refType} onChange={e => setAttnType(e.currentTarget.value)}>
                <option value="paid">Overtime</option>
                <option value="unpaid">UnPaid</option>
                <option value="lieu">Time In Lieu</option>
              </select>

              <select className="form-select ms-1" ref={refDur}>
                {attnType==='paid' && <>
                  {_.map(_.fill(new Array(48),0),(v,idx2) => <option key={idx2} value={(idx2+1)/4} selected={idx2===0}>{((idx2+1)/4).toFixed(2)} Hrs.</option>)}
                </>}
                {attnType==='unpaid' && <>
                  {_.map(_.fill(new Array(48),0),(v,idx2) => <option key={idx2-48} value={(idx2-48)/4} selected={idx2===47}>{((idx2-48)/4).toFixed(2)} Hrs.</option>)}
                </>}
                {attnType==='lieu' && <>
                  {_.map(_.fill(new Array(97),0),(v,idx2) => <option key={idx2-48} value={(idx2-48)/4} selected={idx2===48}>{((idx2-48)/4).toFixed(2)} Hrs.</option>)}
                </>}
              </select>

            </div>
          </>}
        </div>

        <div className="text-center mt-3">
          <Button className="mx-1" variant="secondary" onClick={() => setConfirmAttn(false)}>Cancel</Button>
          <Button className="mx-1" variant="primary" onClick={markAttendence()}>Save Attendance</Button>
        </div>
        </Modal.Body>
      </Modal>);
  };

  const logrecords = () => {
    //return logs.data;
    return _.filter(logs.data,d => d.ontime === (logs.ontime ? "1" : "0"));
  };

  const renderViewLogs = () => {
    return (
      <Modal show={true} size="lg" onHide={() => showViewLogs(false)}>
        <Modal.Header closeButton>
          <b>View Attendance Logs (last {props.attnLogDays} days)</b>
          <div className="flex-fill px-4">
          {members.length > 0 && <select className="form-select my-2" ref={refMember2} onChange={fetchLogs}>
              <option value={userData.uid}>Self</option>
              {_.map(members, (m) => <option key={m.id} value={m.id}>{m.name}</option>)}
            </select>}</div>
        </Modal.Header>
        <Modal.Body>
          {logs.loading && <Alert variant="warning" className="m-0 py-2">
              <ProgressBar variant="info" animated now={100} />
            </Alert>}
          {!logs.loading && <>
            {<ul class="nav nav-pills nav-justified">
              <li class="nav-item">
                <a class={`nav-link ${logs.ontime? "active": ''}`} href="#" onClick={() => setLogs({...logs,ontime: true})}>Normal Hours</a>
              </li>
              <li class="nav-item">
                <a class={`nav-link ${!logs.ontime? "active": ''}`} href="#"  onClick={() => setLogs({...logs,ontime: false})}>Differed Hours</a>
              </li>
            </ul>}
            {logrecords().length === 0 && <div className="alert alert-warning p-2 my-3 text-center">No attendance found!</div>}
            {logrecords().length > 0 && <div className="table my-3">
              <table className="table table-striped table-hover">
              <thead>
                <tr className="bg-light text-dark">
                  <th>Marked On</th>
                  <th>Time</th>
                  <th>Duration</th>
                  {!logs.ontime && <>
                    <th>Type</th>
                    <th>Reason</th>
                    <th className="text-center">Approved?</th>
                  </>}
                  <th className="text-center" style={{width: 40}}><img src={`${process.env.PUBLIC_URL}/images/delete.png`} alt="Delete" style={{width: 15}} /></th>
                  </tr>
              </thead>
              <tbody>
                {logrecords().map((rec, idx) => <tr key={idx}>
                  <td>{moment(rec.login).format('YYYY-MM-DD')} {_.get(rec,'markedBy','')!=='' && <span className="badge bg-dark text-white">{rec.markedBy}</span>}</td>
                  <td>{moment(rec.login).format('hh:mm A')}</td>
                  <td>{rec.duration} Hrs.</td>
                  {!logs.ontime && <>
                      <td>{rec.diftype}</td>
                      <td>{rec.reason}</td>
                      <td className="text-center">{rec.approved === "1" ? "Yes" : "No"}</td>
                    </>}
                  <td className="text-center"><img src={`${process.env.PUBLIC_URL}/images/delete.png`} className="clickable" onClick={() => deleteAttn(rec.id)} title="Click to Delete" style={{width: 15}} /></td>
                </tr>)}
              </tbody>
            </table></div>}
          </>}

        </Modal.Body>
      </Modal>);
  };

  return (
    <>
      {<Row>
        <Col className="text-start" xs={5}>
          {marking===true && (
            <Alert variant="warning" className="m-0 py-2">
              <ProgressBar variant="info" animated now={100} />
            </Alert>
          )}

          {!marking && (
            <>
              {confirmAttn===true && confirmAttendance()}
              <Button
                variant="primary"
                className="m-0 px-2 h-100"
                onClick={() => setConfirmAttn(true)}
              >
                Start Working
              </Button>
              {viewLogs===true && renderViewLogs()}
              
            </>
          )}
        </Col>
        
      </Row>}
    </>
  );
};

export default DateWise;
